import styled from 'styled-components'
import { cores } from '../../styles'

export const CarouselImage = styled.img`
  background-color: #c3c3c3;
  width: auto;
  height: 100%;
  object-fit: cover;
  width: 100%;
`

export const CarouselImageContainer = styled.div`
  height: 200px;
  overflow: hidden;
  position: relative;

  @media (min-width: 768px) {
    height: 400px;
  }

  @media (min-width: 992px) {
    height: 500px;
  }
`

export const LoadingContainer = styled.div`
  height: 300px;
`

export const Loading = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: ${cores.corPrincipalDown};
`
